import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadPowerTypeOptions } from '../store/options.actions'

export function* getVadPowerTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVadPowerTypeOptions])
    const { entity } = response
    yield put(setVadPowerTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadPowerTypeOptions() error: ${e}`))
  }
}
export function* getVadPowerTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVadPowerTypeOptions)
}
